import { Box } from "@chakra-ui/react";
import {
  // call,
  ColorIcon,
  colors,
  customEvent,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  // GoiLogo,
  HackleEventName,
  HStack,
  // LargeButton,
  // LARGEL_BUTTON_TYPE,
  // OverlayModal,
  Spacing,
  VStack,
} from "goi_common";
import // ReactNode,
// useMemo,
"react";
import ParlorRegionBreadcrumb from "../../ParlorRegionContainer/ParlorRegionBreadcrumb";
// import { ConsultReservationModalContent } from "./Modal/ConsultReservationModalContent";
// import { useRouter } from "next/router";
// import { useOverlay } from "@toss/use-overlay";
// import { useGoiCall } from "@/hooks/useGoiCall";

interface MainInfoProps {
  companyName: string;
  address: string;
  sido?: string;
  sigungu?: string;
  isDiscount?: boolean;
  id?: string;
  isExcluded: boolean;
}
function MainInfoSection({
  companyName,
  address,
  sido,
  sigungu,
  isDiscount,
  id,
  isExcluded,
}: MainInfoProps) {
  // const router = useRouter();
  // const overlay = useOverlay();
  // const { goiCall } = useGoiCall({
  //   showModal: true,
  //   path: "parlor_detail",
  // });

  // const onDiscountClick = () => {
  //   goiCall();
  // };

  return (
    <VStack width="100%">
      <VStack padding="16px 24px 12px" alignItems="flex-start" maxWidth="480px">
        <Box position={"relative"} top={0}>
          <ParlorRegionBreadcrumb
            path="parlor_detail"
            sidoName={FUNERAL_SIDO.get(Number(sido)) as string}
            sigunguName={FUNERAL_SIGUNGU.get(Number(sido))?.get(Number(sigungu)) as string}
          />
        </Box>

        {/* {isDiscount && (
          <Box
            mt="8px"
            mb="6px"
            background="rgba(0, 0, 0, 0.5)"
            backdropFilter="blur(2px)"
            borderRadius="18px"
            padding="2px 10px 2px 2px"
          >
            <HStack gap="4px" alignItems="center" justifyContent="center">
              <Box margin="auto" background={colors.gray900} padding="4px" borderRadius="50%">
                <ColorIcon
                  name="icon-medal-check-mono"
                  color={colors.reviewYellow}
                  width={16}
                  height={16}
                />
              </Box>
              <HStack gap="6px" alignItems="center" justifyContent="center">
                <GoiLogo color={colors.white} size={16} />
                <span className="button_12_sb white">빈소 할인 제휴 장례식장</span>
              </HStack>
            </HStack>
          </Box>
        )} */}
        <Box as="h1" className="subtitle1_b gray900">
          {companyName}
        </Box>

        <Spacing gap={8} />
        <HStack width="100%" alignItems="flex-start" justifyContent="space-between" gap={8}>
          <HStack alignItems="flex-start" gap={4} flexGrow={0}>
            <ColorIcon name="location" width="22px" color={colors.orange650} />
            <div className="body3_r gray500">{address}</div>
          </HStack>
          <CopyAddressButton address={address} />
        </HStack>
      </VStack>
    </VStack>
  );
}

// const BadgeIcon = ({
//   icon,
//   title,
//   onClick,
//   hasBorder,
// }: {
//   icon: ReactNode;
//   title: ReactNode;
//   onClick: () => void;
//   hasBorder?: boolean;
// }) => {
//   return (
//     <Box borderRadius="6px" width="100%" border={`1px solid ${colors.gray100}`}>
//       <HStack
//         borderRadius="6px"
//         onClick={onClick}
//         alignItems="center"
//         justifyContent="space-between"
//         padding="6px 2px"
//         gap="6px"
//       >
//         <Box textAlign="center" whiteSpace="pre" margin="auto" className="body_14_m gray700">
//           {title}
//         </Box>
//       </HStack>
//     </Box>
//   );
// };

const CopyAddressButton = ({ address }: { address: string }) => {
  const copyAddress = () => {
    customEvent({
      newGtm: {
        path: "parlor_detail",
        trigger_and_target: "copy-copy_address",
      },
      hackle: { key: HackleEventName["장례식장 상세 - 주소 복사"] },
    });
    navigator.clipboard.writeText(address).then(() => {
      alert("주소가 복사되었습니다.");
    });
  };
  return (
    <HStack
      as="button"
      onClick={copyAddress}
      style={{
        minWidth: "70px",
      }}
      border={`1px solid ${colors.gray100}`}
      borderBottom={`1px solid ${colors.gray100}`}
      padding="2px 4px"
      gap={1}
      borderRadius="4px"
    >
      <ColorIcon name="content-copy-outline" color={colors.gray300} width="16px" height="16px" />
      <div className="caption1 gray300">복사하기</div>
    </HStack>
  );
};

export default MainInfoSection;
